import { render, staticRenderFns } from "./AreaCliente.vue?vue&type=template&id=c6cc440a"
import script from "./AreaCliente.vue?vue&type=script&lang=js"
export * from "./AreaCliente.vue?vue&type=script&lang=js"
import style0 from "./AreaCliente.vue?vue&type=style&index=0&id=c6cc440a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports